import { createStore } from 'vuex'
import { showToast as toast } from '@/helpers/UseToasts'
import groupService from '../services/group.service'
import { mapIdTitleToValueName } from '@/modules/utils/simpleSelect'

export const dataGroups = createStore({
  state: () => {
    return {
      groups: [],
      drawerModal: false,
      drawerModalContent: null,
      companiesCollect: [],
      tabActivatedStudents: false,
      initialCompanySelected: null,

      // form
      form: {
        name: null,
        description: null,
        company_id: null,
        is_active: true,
        students: [],
        trainings: []
      }
    }
  },
  getters: {
    groups: (s) => s.groups,
    getDrawerModal: (state) => state.drawerModal,
    getDrawerModalContent: (state) => state.drawerModalContent,
    getStudentsCollect: (s) => s.form.students,
    getTrainingsCollect: (s) => s.form.trainings,
    getCompanyCollect: (s) => s.companiesCollect,
    getTabActivatedStudents: (s) => s.tabActivatedStudents,
    getInitialCompanySelected: (s) => s.initialCompanySelected
  },
  mutations: {
    RESET_FORM (state) {
      state.form.name = null
      state.form.description = null
      state.form.company_id = null
      state.form.is_active = true
      state.form.students = []
      state.form.trainings = []
    },
    UPDATE_FIELDS_FORM (state, payload) {
      state.form.name = payload.name
      state.form.description = payload.description
      state.initialCompanySelected = payload.companies

      // state.form.is_active = true
      state.form.students = payload.students
      state.form.trainings = payload.trainings
    },
    SET_GROUPS (state, payload) {
      state.groups = null
      state.groups = payload
    },
    SET_DRAWER_ACTIVE (state, payload) {
      state.drawerModalContent = []
      state.drawerModalContent = payload
      state.drawerModal = true
    },
    SET_DRAWER_DESACTIVE (state) {
      state.drawerModal = false
      state.drawerModalContent = []
    },
    RESET (state) {
      state.form.name = null
      state.form.description = null
      state.form.company_id = null
    },
    ADD_STUDENT_COLLECT (state, payload) {
      if (!Array.isArray(state.form.students)) {
        state.form.students = []
      }

      const exists = state.form.students.some(
        item => item.value === payload.value
      )

      if (exists) return

      state.form.students.push(payload)
    },
    ADD_TRAINING_COLLECT (state, payload) {
      if (!Array.isArray(state.form.trainings)) {
        state.form.trainings = []
      }

      const exists = state.form.trainings.some(
        item => item.value === payload.value
      )

      if (exists) return

      state.form.trainings.push(payload)
    },
    SET_COMPANY_COLLECT (state, payload) {
      state.companiesCollect = []
      state.companiesCollect = payload
    },
    SET_TAB_ACTIVATED_IS_STUDENTS (state, payload) {
      state.tabActivatedStudents = payload || false
    }
  },
  actions: {
    setModalActive ({ commit }, payload) {
      commit('SET_DRAWER_ACTIVE', payload)
    },
    setModalDesactive ({ commit }) {
      commit('SET_DRAWER_DESACTIVE')
    },
    async getGroups ({ commit }) {
      await groupService.getAllGroups()
        .then(res => {
          console.log(res.data)
          commit('SET_GROUPS', res.data)
        }).catch(err => {
          toast(
            'Aviso',
            'Algo deu errado ao buscas grupos',
            'error'
          )
        })
    },
    async getCompanyCollect ({ commit }) {
      await groupService.companiesCollect()
        .then(res => {
          commit('SET_COMPANY_COLLECT', res.data)
        }).catch(err => {
          toast(
            'Aviso',
            'Algo deu errado ao buscar empresas',
            'error'
          )
        })
    },
    // tabs
    setTabActivatedstudents ({ commit }, payload) {
      commit('SET_TAB_ACTIVATED_IS_STUDENTS', payload)
    }
  }
})
